module.exports = __webpack_public_path__ + "static/media/skillseeker-logo.66c268f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skillseeker-logo.jpg
// module id = 724
// module chunks = 0